import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Autocomplete,
  alpha,
  AppBar,
  Button,
  Snackbar,
  IconButton,
  InputBase,
  Stack,
  Chip,
  InputLabel,
  styled,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../Utils/AxoisClient";
import Header from "../Header/Header";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import Popup from "../Popup/Popup";
import deleteIcon from "../Assets/deleteIcon.png";
import "./BookmarkView.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
// import { Search } from "@mui/icons-material";
ModuleRegistry.registerModules([AllCommunityModule]);

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: `${theme.shape.borderRadius * 2}px`,
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "white",
  },
  border: "1px solid lightgrey",
  padding: "0px",
  // height:"35PX",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(0),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  color: "lightgrey",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    color: "grey",
    fontSize: "15 px",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const textFieldStyle = {
  background: "white",
  borderRadius: "16px",
  border: "none",

  backgroundColor: "#fff",
  borderRadius: 1,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
  },
};

const gridStyle = {
  borderRadius: "16px",
};
const labelStyle = {
  color: "white",
  fontSize: "1.2rem",
};

// Debounce Hook
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}

const BookmarkView = () => {
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [originCountryList, setOriginCountryList] = useState([]);
  const [destinationCountryList, setDestinationCountryList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [payloadID, setPayloadID] = useState();
  const [filters, setFilters] = useState({
    material: "",
    origin: "",
    destination: "",
  });
  const [loading, setLoading] = useState(true);
  const debouncedSearchText = useDebounce(searchText, 500);
  const navigate = useNavigate();

  // Fetch filter dropdown options
  useEffect(() => {
    const fetchData = () => {
      axiosInstance
        .post("company/bookmark/material-origin-destination-list")
        .then((res) => {
          const d = res?.data?.data;
          setMaterialList(d?.material_names || []);
          setOriginCountryList(d?.origin_countries || []);
          setDestinationCountryList(d?.destination_countries || []);
        })
        .catch((err) => {});
    };
    fetchData();
  }, []);

  // Fetch bookmark list based on filters
  const fetchData = async () => {
    const payload = {
      search_text: debouncedSearchText,
      material_name: filters.material || "",
      origin_country: filters.origin || "",
      destination_country: filters.destination || "",
    };
    try {
      const res = await axiosInstance.post("company/bookmark/list", payload);
      setLoading(false);
      setData(res?.data?.data || []);
    } catch (err) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [debouncedSearchText, filters]);

  // Format data for grid
  useEffect(() => {
    const formatted = data.map((item) => ({
      ...item,
      material: item.material_name,
      hsn: item.hsn_code,
      createdBy: item.created_by,
      createdDate: item.created_date,
      bookmarkTitle: item.bookmark_title,
    }));
    setRowData(formatted);
  }, [data]);

  // Delete bookmark
  const handleDeleteBookmark = async (params) => {
    setOpenPopup(true);
    setPayloadID(params?.data);
    // try {
    //   const res = await axiosInstance.post("company/bookmark/delete", {
    //     id: params?.data?.id,
    //   });
    //   if (res?.data?.message === "Bookmark Deleted Successfully") {
    //     setDeleteSuccess(true);
    //     setData((prev) => prev.filter((item) => item.id !== params.data.id));
    //   }
    // } catch (err) {
    // }
  };

  // View bookmark detail
  const handleView = (params) => {
    navigate("/detail-view", {
      state: {
        id: params?.data?.id,
        selectedHeader: params?.data?.destination_country,
        selectedMaterial: { material_name: params?.data?.material_name },
        from: "bookmark",
        selectedHSCode: {
          hsncode: params?.data?.hsn,
          hs_code_short_description: params?.data?.hs_code_short_description,
        },
      },
    });
  };

  const handleAnalyticsView = (params) => {
    navigate("/analytics", {
      state: {
        params: params,
      },
    });
  };

  // AG Grid Columns
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Bookmark Title",
        field: "bookmarkTitle",
        flex: 1,
        width: 150,
      },
      { headerName: "Material Name", field: "material", flex: 1 },
      { headerName: "HSN Code", field: "hsn", flex: 1, width: 100 },
      { headerName: "Created By", field: "createdBy", flex: 1 },
      { headerName: "Created Date", field: "createdDate", flex: 1 },
      {
        headerName: "Action",
        field: "action",
        headerClass: "last-header-cell",
        flex: 1,
        cellRenderer: (params) => (
          <Stack
            direction="row"
            spacing={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Chip
              label="Analytics"
              sx={{
                background: "#7847DC",
                color: "white",
                minWidth: "50px",
                height: "25px",
                fontSize: "12px", // keep consistent
              }}
              onClick={() => {
                handleAnalyticsView(params?.data);
              }}
            />
            <Chip
              label="View"
              sx={{
                background: "#7847DC",
                color: "white",
                minWidth: "50px",
                height: "25px",
                fontSize: "12px", // keep consistent
              }}
              onClick={() => handleView(params)}
            />
            <Button
              variant="text"
              color="error"
              onClick={() => handleDeleteBookmark(params)}
              style={{
                textTransform: "none",
                minWidth: "30px",
                padding: 0, // align better with chip
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  d="M17.375 3.75H14.25V3.125C14.25 2.62772 14.0525 2.15081 13.7008 1.79917C13.3492 1.44754 12.8723 1.25 12.375 1.25H8.625C8.12772 1.25 7.65081 1.44754 7.29917 1.79917C6.94754 2.15081 6.75 2.62772 6.75 3.125V3.75H3.625C3.45924 3.75 3.30027 3.81585 3.18306 3.93306C3.06585 4.05027 3 4.20924 3 4.375C3 4.54076 3.06585 4.69973 3.18306 4.81694C3.30027 4.93415 3.45924 5 3.625 5H4.25V16.25C4.25 16.5815 4.3817 16.8995 4.61612 17.1339C4.85054 17.3683 5.16848 17.5 5.5 17.5H15.5C15.8315 17.5 16.1495 17.3683 16.3839 17.1339C16.6183 16.8995 16.75 16.5815 16.75 16.25V5H17.375C17.5408 5 17.6997 4.93415 17.8169 4.81694C17.9342 4.69973 18 4.54076 18 4.375C18 4.20924 17.9342 4.05027 17.8169 3.93306C17.6997 3.81585 17.5408 3.75 17.375 3.75ZM8 3.125C8 2.95924 8.06585 2.80027 8.18306 2.68306C8.30027 2.56585 8.45924 2.5 8.625 2.5H12.375C12.5408 2.5 12.6997 2.56585 12.8169 2.68306C12.9342 2.80027 13 2.95924 13 3.125V3.75H8V3.125ZM15.5 16.25H5.5V5H15.5V16.25ZM9.25 8.125V13.125C9.25 13.2908 9.18415 13.4497 9.06694 13.5669C8.94973 13.6842 8.79076 13.75 8.625 13.75C8.45924 13.75 8.30027 13.6842 8.18306 13.5669C8.06585 13.4497 8 13.2908 8 13.125V8.125C8 7.95924 8.06585 7.80027 8.18306 7.68306C8.30027 7.56585 8.45924 7.5 8.625 7.5C8.79076 7.5 8.94973 7.56585 9.06694 7.68306C9.18415 7.80027 9.25 7.95924 9.25 8.125ZM13 8.125V13.125C13 13.2908 12.9342 13.4497 12.8169 13.5669C12.6997 13.6842 12.5408 13.75 12.375 13.75C12.2092 13.75 12.0503 13.6842 11.9331 13.5669C11.8158 13.4497 11.75 13.2908 11.75 13.125V8.125C11.75 7.95924 11.8158 7.80027 11.9331 7.68306C12.0503 7.56585 12.2092 7.5 12.375 7.5C12.5408 7.5 12.6997 7.56585 12.8169 7.68306C12.9342 7.80027 13 7.95924 13 8.125Z"
                  fill="#E40004"
                />
              </svg>
            </Button>
          </Stack>
        ),
      },
    ],
    []
  );

  // Reset all filters
  const handleReset = () => {
    setFilters({ material: "", origin: "", destination: "" });
    setSearchText("");
  };

  return (
    <Box sx={{ p: 0, display: "block" }}>
      {openPopup && (
        <Popup
          open={openPopup}
          usedFor="delete"
          img={deleteIcon}
          material_name={payloadID?.bookmark_title}
          redirectPath="/bookmark-data"
          handleClose={() => setOpenPopup(false)}
          handleReload={fetchData}
          title="Are You Sure Want To Delete Workspace?"
          firstButton="Delete"
          secondButton="Cancel"
          apiEndPoint="company/bookmark/delete"
          payload={{
            id: payloadID?.id,
          }}
          description="This is a dynamic modal opened on button click."
        />
      )}
      <Header />
      <Box
        sx={{
          background:
            "var(--PR-gradient,linear-gradient(90deg, rgba(120, 71, 220, 0) -5.62%, #5526b7 126.61%),  #000)",
          color: "#fff",
          // borderRadius: 2,
          p: 2,
          mt: "55px",
          display: "block",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            p: 2,
            pl: 0,
            color: "#ba99ff",
            fontWeight: 600,
            fontFamily: '"lora", sans-serif',
          }}
        >
          My Saved Workspace
        </Typography>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={3} lg={12}>
            <Box>
              <InputLabel shrink sx={labelStyle}>
                Search by title or material
              </InputLabel>
              <Search sx={{ marginRight: 0 }}>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search here..."
                  inputProps={{ "aria-label": "search" }}
                  // sx={textFieldStyle}
                  size="small"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </Search>
            </Box>
          </Grid>

          <Grid item xs={12} md={2} lg={3.5} sx={gridStyle}>
            <InputLabel shrink sx={labelStyle}>
              Material Name
            </InputLabel>
            <Autocomplete
              options={materialList}
              value={filters.material}
              onChange={(e, value) =>
                setFilters((prev) => ({ ...prev, material: value }))
              }
              getOptionLabel={(option) => option || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Material Name"
                  size="small"
                  sx={textFieldStyle}
                />
              )}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={2} lg={3.5} sx={gridStyle}>
            <InputLabel shrink sx={labelStyle}>
              Origin Country
            </InputLabel>
            <Autocomplete
              options={originCountryList}
              value={filters.origin}
              onChange={(e, value) =>
                setFilters((prev) => ({ ...prev, origin: value }))
              }
              getOptionLabel={(option) => option || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Origin Country"
                  size="small"
                  sx={textFieldStyle}
                />
              )}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={2} lg={3.5} sx={gridStyle}>
            <InputLabel shrink sx={labelStyle}>
              Destination Country
            </InputLabel>
            <Autocomplete
              options={destinationCountryList}
              value={filters.destination}
              onChange={(e, value) =>
                setFilters((prev) => ({ ...prev, destination: value }))
              }
              getOptionLabel={(option) => option || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Destination Country"
                  size="small"
                  sx={textFieldStyle}
                />
              )}
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            lg={1.5}
            sx={gridStyle}
            gap={1}
            alignItems="center"
          >
            {" "}
            <InputLabel shrink sx={{ visibility: "hidden" }}>
              Reset
            </InputLabel>
            <Box>
              {" "}
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          height: "90vh",
          overflowX: "auto",
          position: "relative",
          m: 0,
          p: 0,
          "& .ag-header": { borderBottom: "none", borderRadius: 0 },
          "& .ag-root-wrapper": { border: "none", borderRadius: 0 },
          "& .ag-header-viewport": { borderBottom: "none", borderRadius: 0 },
        }}
      >
        <div
          className="ag-theme-alpine my-gradient-header-bookmark "
          style={{ margin: 0, padding: 0, height: "90%" }}
        >
          {loading ? (
            <SkeletonTable rows={6} columns={3} />
          ) : (
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={{
                resizable: true,
                tooltipValueGetter: (params) => {
                  return params?.data?.bookmarkTitle;
                },
              }}
              enableBrowserTooltips={true}
              pagination
              paginationPageSize={10}
              rowHeight={40}
              headerHeight={50}
              // rowSelection="multiple"
              style={{ margin: 1 }}
              paginationPageSizeSelector={[10, 20, 50, 100]}
              getRowClass={(params) =>
                params.node.rowIndex % 2 === 0 ? "even-row" : "odd-row"
              }
              localeText={{
                pageSizeSelectorLabel: "Rows per page",
              }}
            />
          )}
        </div>

        {rowData?.length === 0 && (
          <Typography align="center" mt={4}>
            No bookmarks found.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookmarkView;
